













import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Config from '../../utils/Config';
import Button from '../Button.vue';
import { MESSAGE_TYPE } from '../../vo/ChatMessageData';
import SockController, { SOCK_ACTIONS } from '../../controller/SockController';

@Component({
	components:{
		Button,
	}
})
export default class ConstToStar extends Vue {

	public constellation:string = "aquila";
	public star:string = "α";

	public get constList():string[] {
		return Config.CONSTELLATION_LIST.sort();
	}

	public get starList():string[] {
		return Config.STAR_NAME_LIST;//.sort();
	}

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

	public submit():void {
		let data = {
			type:MESSAGE_TYPE.CONST_TO_STAR,
			star:this.star,
			constellation:this.constellation,
			from:this.$store.state.me.id,
		}
		SockController.instance.sendMessage({action:SOCK_ACTIONS.SEND_MESSAGE, includeSelf:true, data});
	}

}
